import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import classnames from "classnames"; // Components

import Icon from "../../Icon";
export var Checkbox = function Checkbox(a) {
  var b = a.id,
      c = a.name,
      d = a.icon,
      e = a.label,
      f = a.labelStyle,
      g = void 0 === f ? {} : f,
      h = a.image,
      i = a.imageStyle,
      j = void 0 === i ? {} : i,
      k = _objectWithoutProperties(a, ["id", "name", "icon", "label", "labelStyle", "image", "imageStyle"]);

  c || (c = e.toLowerCase());
  var l = classnames(k.className, "checkbox", {
    checkbox__icon: d
  });
  return /*#__PURE__*/React.createElement("span", {
    className: classnames(l, {
      hasImage: h
    })
  }, /*#__PURE__*/React.createElement("input", Object.assign({
    type: "checkbox",
    id: b,
    name: c
  }, k)), d ? /*#__PURE__*/React.createElement(Icon, {
    icon: d,
    tag: "label",
    htmlFor: b,
    style: g
  }, e) : /*#__PURE__*/React.createElement("label", {
    htmlFor: b,
    style: g,
    className: classnames({
      "no-icon": !d
    })
  }, h && /*#__PURE__*/React.createElement("img", {
    src: h,
    alt: e,
    className: "logo",
    style: j
  }), e));
};
export default Checkbox;